const data = {
	"body": "<circle cx=\"4\" cy=\"12\" r=\"1\" fill=\"currentColor\"/><rect width=\"14\" height=\"2\" x=\"7\" y=\"11\" fill=\"currentColor\" rx=\".94\" ry=\".94\"/><rect width=\"18\" height=\"2\" x=\"3\" y=\"16\" fill=\"currentColor\" rx=\".94\" ry=\".94\"/><rect width=\"18\" height=\"2\" x=\"3\" y=\"6\" fill=\"currentColor\" rx=\".94\" ry=\".94\"/>",
	"width": 24,
	"height": 24
};
export default data;
